import { render, staticRenderFns } from "./SelectEvents.vue?vue&type=template&id=0fa09423&scoped=true"
import script from "./SelectEvents.vue?vue&type=script&lang=js"
export * from "./SelectEvents.vue?vue&type=script&lang=js"
import style0 from "./SelectEvents.vue?vue&type=style&index=0&id=0fa09423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa09423",
  null
  
)

export default component.exports